/*
 * @Description: 公共配置 公共协议等
 * @Author: zhanjunwei
 * @Date: 2025-02-27 14:11:25
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-02-27 14:33:37
 */
export const agreementConfig = {
  // 腾讯SSV平台服务协议
  SSV: 'https://cdn-digital.ssv.qq.com/ssv_privacy/business_service.html',
  // 数字工具箱合作指引
  cooperationGuide:
    'https://docs.qq.com/aio/p/scso1h7k09247zi?p=ikGoKXjbtJBtdA1TwLAAd2',
  // SSV平台使用指引 - 首页
  useGuideHome:
    'https://docs.qq.com/aio/p/scso1h7k09247zi?p=yTpX1KzG2o5upePyCpU1wq',
  // SSV平台使用指引 - 数字工具箱申领与使用说明
  useGuideApply:
    'https://docs.qq.com/aio/p/scso1h7k09247zi?p=fZ7JMUpNgY3AjoYsXtKBMZ',
  // SSV平台使用指引 - 不同账号类型、角色权限说明
  useGuideRole:
    'https://docs.qq.com/aio/p/scso1h7k09247zi?p=CqNjhESadjxiD8b2to0Elt&nlc=1',
};
